var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgEs = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 3 2"
}, props), /* @__PURE__ */ React.createElement("path", {
  fill: "#c60b1e",
  d: "M0 0h3v2H0z"
}), /* @__PURE__ */ React.createElement("path", {
  fill: "#ffc400",
  d: "M0 .5h3v1H0z"
}));
export { SvgEs as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjxwYXRoIGZpbGw9IiNjNjBiMWUiIGQ9Ik0wIDBoM3YySDB6Ii8+PHBhdGggZmlsbD0iI2ZmYzQwMCIgZD0iTTAgLjVoM3YxSDB6Ii8+PC9zdmc+";
